<template>
    <div>
        <div v-if="series && options">
            <apexchart type="line" :options="chartOptions" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.options = this.chartOptions;
        this.series = this.seriesData;
        // this.$forceUpdate();
    },
    props: ["chartOptions", "seriesData"],
    data() {
        return {
            series: [],
            options: {}
        };
    },
    methods: {},
    watch: {
        chartOptions: {
            handler(newVal, oldVal) {
                this.options = newVal;
                this.$forceUpdate();
            },
            deep: true
        },
        seriesData(val) {
            this.series = val;
        }
    }
};
</script>

<style>
</style>